import React, { FunctionComponent } from "react";
import StyledTitle from "./style";

export type PageTitleProps = {
  title: string
  subtitle?: string
}

export const PageTitle: FunctionComponent<PageTitleProps> = ({title, subtitle}) => {
  return (
    <div>
      <StyledTitle variant="h2">{title}</StyledTitle>
      {subtitle && <StyledTitle variant="h4">{subtitle}</StyledTitle>}
    </div>
  );
};